var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"title":"Настройки"}},[_c('a-tabs',_vm._l((_vm.tabs),function(tab){return _c('a-tab-pane',{key:tab.key,attrs:{"tab":tab.title,"disabled":tab.disabled}},[_c(tab.component,{tag:"component"})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }